import Model, { attr, belongsTo, hasMany, type HasMany } from '@ember-data/model';
import type { Type } from '@warp-drive/core-types/symbols';

import type Entry from './entry';
import type Invite from './invite';
import type Questionnaire from './questionnaire';
import type QuestionnaireFieldResponse from './questionnaire-field-response';

export default class QuestionnaireResponse extends Model {
  declare [Type]: 'questionnaire-response';

  @belongsTo('questionnaire', { async: false, inverse: null })
  declare questionnaire: Questionnaire;

  @belongsTo('respondent', { async: false, inverse: null, polymorphic: true })
  declare respondent: Entry | Invite;

  @hasMany('questionnaire-field-response', { async: false, inverse: 'questionnaireResponse' })
  declare questionnaireFieldResponses: HasMany<QuestionnaireFieldResponse>;

  @attr('boolean') declare passed: boolean;
  @attr('number') declare score: number;
}
